import React from "react";
import { schoolNameForDocument } from "@/lib/schoolDocument";

const MINISTRY_LOGO = "/branding/ministry-education.png";
const SCHOOL_LOGOS = {
  abaq: "/branding/school-abaq.png",
  durat: "/branding/school-durat.png",
};

export function schoolLogoFor(schoolKey) {
  return SCHOOL_LOGOS[schoolKey] || "";
}

export default function SchoolDocumentHeader({
  schoolKey,
  gender = "",
  schoolName = "",
  ministryLogo = MINISTRY_LOGO,
  schoolLogo: schoolLogoOverride = "",
  className = "",
}) {
  const schoolLogo = schoolLogoOverride || schoolLogoFor(schoolKey);
  const documentSchoolName = schoolNameForDocument(schoolKey, gender, schoolName);
  return (
    <table
      className={`school-document-header ${className}`}
      data-school-document-header="true"
      data-school-key={schoolKey || ""}
      dir="rtl"
    >
      <tbody><tr>
        <td className="school-document-government">
          <strong>المملكة العربية السعودية</strong>
          <span>وزارة التعليم</span>
          <span>الإدارة العامة للتعليم بمحافظة جدة</span>
          <span>مكتب التعليم الخاص بجدة</span>
          {documentSchoolName && <strong>{documentSchoolName}</strong>}
        </td>
        <td><img className="school-document-ministry-logo" src={ministryLogo} alt="شعار وزارة التعليم" /></td>
        <td>{schoolLogo ? (
          <img className="school-document-school-logo" src={schoolLogo} alt={`شعار ${documentSchoolName || "المدرسة"}`} />
        ) : <div className="school-document-school-placeholder" />}</td>
      </tr></tbody>
    </table>
  );
}
